import { useCallback, useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { KSelect } from '@/ui-library/components/molecules/KSelect';
import { SelectDocument } from './SelectDocument';
import { DocumentList } from './DocumentList';

export const FolderEntry = ({
  entry,
  index,
  categories,
  selectableAttachments,
  onUpdateEntry,
  selectedFolderIds = [],
  integrationName,
}) => {
  const categoryOptions = useMemo(
    () =>
      categories.map((cat) => ({
        label: cat.name,
        value: cat.id,
        isDisabled:
          selectedFolderIds.includes(cat.id) && cat.id !== entry.folderId,
      })),
    [categories, selectedFolderIds, entry.folderId]
  );

  const selectedFolderOption = categoryOptions.find(
    (opt) => opt.value === entry.folderId
  );

  const handleFolderChange = useCallback(
    (selectedOption) => {
      const selectedId = selectedOption?.value || '';
      const selectedCategory = categories.find((c) => c.id === selectedId);
      onUpdateEntry(index, {
        ...entry,
        folderId: selectedId,
        folderName: selectedCategory?.name || '',
      });
    },
    [categories, entry, index, onUpdateEntry]
  );

  const handleDocumentsAdded = useCallback(
    (newDocs) => {
      onUpdateEntry(index, {
        ...entry,
        documents: [...entry.documents, ...newDocs],
      });
    },
    [entry, index, onUpdateEntry]
  );

  const handleRemoveDocument = useCallback(
    (docIndex) => {
      onUpdateEntry(index, {
        ...entry,
        documents: entry.documents.filter((_, i) => i !== docIndex),
      });
    },
    [entry, index, onUpdateEntry]
  );

  return (
    <Box
      border="1px solid"
      borderColor="border-color"
      borderRadius="8px"
      p="16px"
      mb="16px"
    >
      <KText size="sm-semi-bold" color="secondary-800" mb="8px">
        Destination folder in {integrationName}
      </KText>
      <Box mb="12px">
        <KSelect
          placeholder="Select folder"
          value={selectedFolderOption || null}
          onChange={handleFolderChange}
          options={categoryOptions}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </Box>

      {entry.folderId && (
        <>
          <SelectDocument
            selectableAttachments={selectableAttachments}
            existingDocuments={entry.documents}
            onDocumentsAdded={handleDocumentsAdded}
          />
          <DocumentList
            documents={entry.documents}
            onRemove={handleRemoveDocument}
          />
        </>
      )}
    </Box>
  );
};
